import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  selectCurrentStep,
  selectStepperFormDraft,
  StepperFormActions,
  selectIsFormDraftSent,
  selectIsStartKycLoading,
  KYCActions
} from "@redux";
import { routerPath, TOTAL_STEPS } from "@config";
import { Notification, NOTIFICATION_TYPES } from "@components";
import { i18, trb } from "@utilities";

const useFormStepControl = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const formDraft = useSelector(selectStepperFormDraft);
  const isSent = useSelector(selectIsFormDraftSent);
  const isSubmitting = useSelector(selectIsStartKycLoading);
  // currentStep is one behind actual route
  const currentStep = useSelector(selectCurrentStep);

  const [submitType, setSubmitType] = useState();

  const handleActionButtonClick = useCallback(e => {
    setSubmitType(e.currentTarget.name);
  }, []);

  const finishForm = useCallback(
    async data => {
      if (formDraft.finishedSteps !== TOTAL_STEPS - 1) {
        Notification({
          type: NOTIFICATION_TYPES.ERROR,
          message: trb(i18.NotificationMessages.NotAllStepsFinished)
        });
        return;
      }

      await dispatch(KYCActions.submitApplication(data));
      document.body.scrollTop = 0;
      history.push(routerPath.kyc);
    },
    [formDraft.finishedSteps, dispatch]
  );

  const submitStep = useCallback(
    async (data, type) => {
      const newStep = type === "next" ? currentStep + 1 : currentStep - 1;
      const newData = {
        personData: data,
        currentStep: newStep
      };
      await dispatch(
        StepperFormActions.saveFormDraft({
          data: newData
        })
      );
      document.body.scrollTop = 0;
      history.push(
        `${routerPath.newKycSme.basePath}/${type === "next" ? newStep + 1 : currentStep}`
      );
    },
    [currentStep, dispatch]
  );

  const submitForm = useCallback(
    async (data, type = "next", isLastStep = false) => {
      try {
        if (isLastStep) {
          finishForm(data);
          return;
        }
        submitStep(data, type);
      } catch (e) {}
    },
    [currentStep, submitStep, finishForm]
  );

  const validateForm = useCallback((values, context, callback) => {
    if (context.submitType === "prev") {
      return { values, errors: {} };
    }
    return callback();
  }, []);

  return {
    formDraft,
    submitForm,
    isSent: isSent || isSubmitting,
    handleActionButtonClick,
    submitType,
    validateForm
  };
};

export default useFormStepControl;
